// import React, { useEffect, useState } from 'react'
// import axios from 'axios'
// import Swal from 'sweetalert2'
// import Navbar from './Navbar'
// import { useNavigate } from 'react-router-dom'

// const AssessmentTwo = () => {
//   const [questions, setQuestions] = useState([])
//   const [responses, setResponses] = useState({})
//   const navigate = useNavigate()

//   // Fetch questions on mount
//   useEffect(() => {
//     axios
//       .get('https://aimuseumbackend.teslabird.com/api/cd/questions/', {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem('access')}`,
//         },
//       })
//       .then((res) => setQuestions(res.data))
//       .catch((err) => console.error('Failed to load questions', err))
//   }, [])

//   const handleResponseChange = (questionId, value) => {
//     setResponses((prev) => ({
//       ...prev,
//       [questionId]: value, // store numeric value directly
//     }))
//   }
//   const handleSubmit = async (e) => {
//     e.preventDefault()

//     const payload = {
//       answers: Object.entries(responses).map(([id, value]) => ({
//         question_id: parseInt(id),
//         answer: value, // now a number 0–4
//       })),
//     }

//     try {
//       await axios.post(
//         'https://aimuseumbackend.teslabird.com/api/cd/submit/',
//         payload,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${localStorage.getItem('access')}`,
//           },
//         }
//       )

//       Swal.fire({
//         icon: 'success',
//         title: 'Test Submitted!',
//         text: 'Redirecting to result...',
//         timer: 2000,
//         showConfirmButton: false,
//       })

//       setTimeout(() => navigate('/result-two'), 2000)
//     } catch (error) {
//       console.error('Submission failed', error)
//       Swal.fire('Error', 'Failed to submit the test', 'error')
//     }
//   }

//   const options = [
//     { label: 'Not true at all', value: 0 },
//     { label: 'Rarely true', value: 1 },
//     { label: 'Sometimes true', value: 2 },
//     { label: 'Often true', value: 3 },
//     { label: 'True nearly all of the time', value: 4 },
//   ]
//   return (
//     <>
//       <Navbar />
//       <div
//         className='container-fluid py-4'
//         style={{
//           background: 'linear-gradient(to bottom left, #e6f7ff, #ffffff)',
//         }}
//       >
//         <div
//           style={{
//             maxWidth: '1000px',
//             margin: '0 auto',
//             padding: '20px',
//             fontFamily: 'Arial, sans-serif',
//           }}
//         >
//           <div className='container'>
//             <div className='row mb-4'>
//               <div className='col-12'>
//                 {/* Title */}
//                 <h2
//                   style={{
//                     color: '#2D5272',
//                     textAlign: 'center',
//                     fontWeight: '600',
//                     fontFamily: 'Inter',
//                     fontsize: '45px',
//                     marginBottom: '50px',
//                   }}
//                 >
//                   Connor-Davidson Resilience Scale: (CD-RISC-10), 2003
//                 </h2>

//                 {/* Description */}

//                 <p
//                   className='mb-3'
//                   style={{
//                     color: '#495057',
//                     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                     lineHeight: '1.6',
//                   }}
//                 >
//                   Resilience is a personal trait that helps people thrive in the
//                   face of adversity and bounce back after stressful events,
//                   tragedies, or trauma. In today's changing world, it is
//                   necessary for everyone to have high resilience to stress.
//                 </p>

//                 <p
//                   className='mb-3'
//                   style={{
//                     color: '#495057',
//                     fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
//                     lineHeight: '1.6',
//                   }}
//                 >
//                   The CD-RISC contains 10 items, all of which carry a 5-point
//                   range of responses, as follows: not true at all (0), rarely
//                   true (1), sometimes true (2), often true (3), and true nearly
//                   all of the time (4). The scale is rated based on how the
//                   subject has felt over the past month.
//                 </p>

//                 <p
//                   style={{
//                     fontSize: '14px',
//                     fontWeight: 'bold',
//                     marginTop: '20px',
//                     marginBottom: '40px',
//                   }}
//                 >
//                   Instructions: Tick any one of the Responses from Not true at
//                   all, Rarely true, Sometimes true, Often True, True nearly all
//                   of the time, based on how you felt over the past month.
//                 </p>

//                 {/* Questions */}
//                 <form onSubmit={handleSubmit}>
//                   {questions.map((q, i) => (
//                     <div className='mb-4 pb-3' key={q.id}>
//                       <h5 className='mb-3'>
//                         {i + 1}. {q.question_text}
//                       </h5>
//                       <div className='row'>
//                         {options.map((option, idx) => (
//                           <div
//                             className='col-12 col-sm-6 col-lg-4 mb-2'
//                             key={idx}
//                           >
//                             <div className='form-check'>
//                               <input
//                                 className='form-check-input'
//                                 type='radio'
//                                 name={`question${q.id}`}
//                                 id={`q${q.id}_opt${idx}`}
//                                 value={option.value}
//                                 checked={responses[q.id] === option.value}
//                                 onChange={() =>
//                                   handleResponseChange(q.id, option.value)
//                                 }
//                               />
//                               <label
//                                 className='form-check-label ms-2'
//                                 htmlFor={`q${q.id}_opt${idx}`}
//                               >
//                                 {option.label}
//                               </label>
//                             </div>
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   ))}
//                   <div className='text-center'>
//                     <button
//                       type='submit'
//                       className='btn btn-primary rounded-pill px-4'
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 </form>

//                 {/* Submit Button */}
//                 {/* <div className='row mt-4'>
//                   <div className='col-12 text-center'>
//                     <button
//                       type='submit'
//                       className='btn btn-primary'
//                       style={{
//                         backgroundColor: '#2c5282',
//                         borderColor: '#2c5282',
//                         padding: '8px 24px',
//                         borderRadius: '25px',
//                       }}
//                     >
//                       Submit
//                     </button>
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }

// export default AssessmentTwo

import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Swal from 'sweetalert2'
import { useNavigate } from 'react-router-dom'
import Navbar from './Navbar'

const AssessmentTwo = () => {
  const [questions, setQuestions] = useState([])
  const [responses, setResponses] = useState({})
  const [loadingQuestions, setLoadingQuestions] = useState(true)
  const [submitting, setSubmitting] = useState(false)
  const navigate = useNavigate()

  // Fetch questions
  useEffect(() => {
    axios
      .get('https://aimuseumbackend.teslabird.com/api/cd/questions/', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access')}`,
        },
      })
      .then((res) => setQuestions(res.data))
      .catch((err) => console.error('Failed to load questions', err))
      .finally(() => setLoadingQuestions(false))
  }, [])

  const handleResponseChange = (questionId, value) => {
    setResponses((prev) => ({
      ...prev,
      [questionId]: value,
    }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setSubmitting(true)

    const payload = {
      answers: Object.entries(responses).map(([id, value]) => ({
        question_id: parseInt(id),
        answer: value,
      })),
    }

    try {
      await axios.post(
        'https://aimuseumbackend.teslabird.com/api/cd/submit/',
        payload,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access')}`,
          },
        }
      )

      Swal.fire({
        icon: 'success',
        title: 'Test Submitted!',
        text: 'Redirecting to result...',
        timer: 2000,
        showConfirmButton: false,
      })

      setTimeout(() => navigate('/result-two'), 2000)
    } catch (error) {
      console.error('Submission failed', error)
      Swal.fire('Error', 'Failed to submit the test', 'error')
    } finally {
      setSubmitting(false)
    }
  }

  const options = [
    { label: 'Not true at all', value: 0 },
    { label: 'Rarely true', value: 1 },
    { label: 'Sometimes true', value: 2 },
    { label: 'Often true', value: 3 },
    { label: 'True nearly all of the time', value: 4 },
  ]

  return (
    <>
      <Navbar />
      <div
        className='container-fluid py-4'
        style={{
          background: 'linear-gradient(to bottom left, #e6f7ff, #ffffff)',
        }}
      >
        <div
          style={{
            maxWidth: '1000px',
            margin: '0 auto',
            padding: '20px',
            fontFamily: 'Arial, sans-serif',
          }}
        >
          {loadingQuestions ? (
            <div className='text-center py-5'>
              <div className='spinner-border text-primary' role='status'>
                <span className='visually-hidden'>Loading...</span>
              </div>
              <p className='mt-3'>Loading questions...</p>
            </div>
          ) : (
            <div className='container'>
              <div className='row mb-4'>
                <div className='col-12'>
                  <h2
                    style={{
                      color: '#2D5272',
                      textAlign: 'center',
                      fontWeight: '600',
                      fontFamily: 'Inter',
                      fontSize: '45px',
                      marginBottom: '50px',
                    }}
                  >
                    Connor-Davidson Resilience Scale: (CD-RISC-10), 2003
                  </h2>

                  <p
                    className='mb-3'
                    style={{
                      color: '#495057',
                      fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                      lineHeight: '1.6',
                    }}
                  >
                    Resilience is a personal trait that helps people thrive in
                    the face of adversity and bounce back after stressful
                    events, tragedies, or trauma. In today's changing world, it
                    is necessary for everyone to have high resilience to stress.
                  </p>

                  <p
                    className='mb-3'
                    style={{
                      color: '#495057',
                      fontSize: 'clamp(0.9rem, 2.5vw, 1rem)',
                      lineHeight: '1.6',
                    }}
                  >
                    The CD-RISC contains 10 items, all of which carry a 5-point
                    range of responses, as follows: not true at all (0), rarely
                    true (1), sometimes true (2), often true (3), and true
                    nearly all of the time (4). The scale is rated based on how
                    the subject has felt over the past month.
                  </p>

                  <p
                    style={{
                      fontSize: '14px',
                      fontWeight: 'bold',
                      marginTop: '20px',
                      marginBottom: '40px',
                    }}
                  >
                    Instructions: Tick any one of the responses based on how you
                    felt over the past month.
                  </p>

                  <form onSubmit={handleSubmit}>
                    {questions.map((q, i) => (
                      <div className='mb-4 pb-3' key={q.id}>
                        <h5 className='mb-3'>
                          {i + 1}. {q.question_text}
                        </h5>
                        <div className='row'>
                          {options.map((option, idx) => (
                            <div
                              className='col-12 col-sm-6 col-lg-4 mb-2'
                              key={idx}
                            >
                              <div className='form-check'>
                                <input
                                  className='form-check-input'
                                  type='radio'
                                  name={`question${q.id}`}
                                  id={`q${q.id}_opt${idx}`}
                                  value={option.value}
                                  checked={responses[q.id] === option.value}
                                  onChange={() =>
                                    handleResponseChange(q.id, option.value)
                                  }
                                />
                                <label
                                  className='form-check-label ms-2'
                                  htmlFor={`q${q.id}_opt${idx}`}
                                >
                                  {option.label}
                                </label>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))}
                    <div className='text-center mt-4'>
                      <button
                        type='submit'
                        className='btn btn-primary rounded-pill px-4'
                        disabled={submitting}
                      >
                        {submitting ? (
                          <>
                            <span
                              className='spinner-border spinner-border-sm me-2'
                              role='status'
                              aria-hidden='true'
                            ></span>
                            Submitting...
                          </>
                        ) : (
                          'Submit'
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export default AssessmentTwo
